import React from 'react';
import { Link } from 'react-router-dom';
import './ProjectCard.css';

const ProjectCard = ({ project }) => {
  return (
    <div className="project-card">
      <div className="project-image">
        {/* <img src={`/images/${project.image}`} alt={project.title} /> */}
        <img src={project.image} alt={project.title}/>
      </div>
      <div className="project-info">
        <h3>{project.title}</h3>
       <Link to="/projects" className="view-button">View Project</Link>
      </div>
    </div>
  );
};

export default ProjectCard;